import React, { type MouseEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import ArrowCurvedUpLeftIcon from '@atlaskit/icon-lab/core/arrow-curved-up-left';

import { usePageContentId } from '@confluence/page-context';
import { useAddCommentPermissionCheck } from '@confluence/comments-hooks/entry-points/useAddCommentPermissionCheck';

const messages = defineMessages({
	reply: {
		id: 'comments-common.comments.replies.footer.reply',
		defaultMessage: 'Reply',
		description: 'Label for the button to reply to a comment',
	},
});

type ReplyButtonProps = {
	handleReplyButtonClick: (event: MouseEvent<HTMLButtonElement>) => void;
	isParentCommentOpen: boolean;
	isStandaloneComment: boolean;
	isOffline?: boolean;
};

export const ReplyButton = ({
	handleReplyButtonClick,
	isParentCommentOpen,
	isStandaloneComment,
	isOffline,
}: ReplyButtonProps) => {
	const { formatMessage } = useIntl();

	const [contentId = ''] = usePageContentId();
	const { canAddComments } = useAddCommentPermissionCheck(contentId);

	if (!canAddComments || !isParentCommentOpen || isStandaloneComment) {
		return null;
	}

	return (
		<Button
			appearance="subtle"
			isDisabled={isOffline}
			onClick={handleReplyButtonClick}
			iconBefore={ArrowCurvedUpLeftIcon}
		>
			{formatMessage(messages.reply)}
		</Button>
	);
};
